import { FilterHandlerBase } from './filter-handler-base';
import { FilterResultFacade } from '../../filter-result-facade';
import { FilterOptions, FilterPassParams } from '../../filter-types';

export abstract class SeriesFilterHandler extends FilterHandlerBase {
  getFilterOptions(filterOptions: FilterOptions): void {
    return;
  }
  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const data = params.deal;
    return result.someSeriesPassedFilter(data.id, this.name);
  }
}
